import React, { useEffect } from 'react'
import { BASE_URL } from '../../Utils/BaseUrl';
import axios from 'axios'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { getProfiledata } from '../../../Store/ProdataAction';

const ProfileSection = () => {

    const prodata = useSelector((state) => state.ProData.profiledata);
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getProfiledata())
    }, [dispatch])

    return (
        <>
            {prodata.map((item) => {

                const firstLetter = item.firstname ? item.firstname.charAt(0).toUpperCase() : "";
                const lastLetter = item.lastname ? item.lastname.charAt(0).toUpperCase() : "";

                return (
                    <div className="user-data full-width" key={item.id}>
                        <div className="user-profile">
                            <div className="username-dt">
                                <div className="usr-pic">

                                    {item.profile_image ? (
                                        <img
                                            src={`https://thetalentclub.co.in/upload/profile/${item.profile_image}`}
                                            alt="profile"
                                        />
                                    ) : (
                                        <div className="avatar-fallback">
                                            {firstLetter}{lastLetter}
                                        </div>
                                    )}

                                </div>
                            </div>

                            <div className="user-specs">
                                <h3>{item.firstname} {item.lastname}</h3>
                                <span>{item.bio}</span>
                            </div>
                        </div>

                        <ul className="user-fw-status">
                            <li>
                                <Link to="/profile">View Profile</Link>
                            </li>
                        </ul>
                    </div>
                )
            })}
            {/* <style jsx>{`
.avatar-fallback{
    width:50px;
    height:50px;
    border-radius:50%;
    background:#F37731;
    color:#fff;
    display:flex;
    align-items:center;
    justify-content:center;
    font-weight:bold;
    font-size:18px;
}
      `}</style> */}
        </>
    )
}

export default ProfileSection